import { WAREHOUSE_TYPES } from "./constants.js";
import { getWarehouseType } from "./getWarehouseType.js";
import { getWarehouseUrlFriendlyAddress } from "./getWarehouseUrlFriendlyAddress.js";
import { LOCATION_SEARCH_PARAM_KEY } from "./warehouseDrawer.constants.js";
import { getSlug } from "./warehouseHelpers.js";
const getWarehouseUrl = ({
  enableModUrlPath,
  locationSearchParam,
  warehouseData,
  warehousesPageBaseUrl,
  warehousesPageUrlSuffix
}) => {
  if (!warehousesPageBaseUrl || !(warehouseData == null ? void 0 : warehouseData.warehouseId)) {
    return null;
  }
  let warehouseUrl = "";
  if (enableModUrlPath) {
    const warehouseType = getWarehouseType(warehouseData);
    const warehouseId = warehouseData.warehouseId;
    const { city, territoryOrCountry } = getWarehouseUrlFriendlyAddress(
      warehouseData.address
    );
    const baseUrlWithCityTerritory = `${warehousesPageBaseUrl}/${territoryOrCountry}/${city}`;
    if (warehouseType === WAREHOUSE_TYPES.BUSINESS_CENTER) {
      warehouseUrl = `${baseUrlWithCityTerritory}/bd/${warehouseId}`;
    } else if (warehouseType === WAREHOUSE_TYPES.SHOWROOM) {
      warehouseUrl = `${baseUrlWithCityTerritory}/showroom/${warehouseId}`;
    } else {
      warehouseUrl = `${baseUrlWithCityTerritory}/${warehouseId}`;
    }
  } else {
    warehouseUrl = `${warehousesPageBaseUrl}${getSlug(warehouseData)}${warehousesPageUrlSuffix}`;
  }
  const separator = (warehouseUrl == null ? void 0 : warehouseUrl.includes("?")) ? "&" : "?";
  warehouseUrl = locationSearchParam ? `${warehouseUrl}${separator}${LOCATION_SEARCH_PARAM_KEY}=${locationSearchParam}` : warehouseUrl;
  return warehouseUrl;
};
export {
  getWarehouseUrl
};
